import React from "react";
import { Route } from "react-router-dom";
import gameRoutes from "./gameRoutes";
import MeetingXframe from "../../components/geriactive/meetings/MeetingXframe";
import Music from "../../components/geriactive/music/Music";
import ExerciseXframe from "../../components/geriactive/exercise/ExerciseXframe";
import LifeLongLearningXframe from "../../components/geriactive/lifeLongLearning/LifeLongLearningXframe";
import MeditationXframe from "../../components/geriactive/meditiation/MeditationXframe";
import MusicSelector from "../../components/geriactive/music/MusicSelector";
import WeatherWeek from "../../components/geriactive/weather/WeatherWeek";
import HomePage from "../../components/geriactive/HomePage";
import VideoResources from "../../components/geriactive/resources/VideoResources";
import KaraokeResources from "../../components/geriactive/resources/KaraokeResources";
import ResourceSelector from "../../components/geriactive/resources/ResourceSelector";
import PrintableActivities from "../../components/geriactive/resources/PrintableActivities";
import PlanningTools from "../../components/geriactive/resources/PlanningTools";
import Training from "../../components/geriactive/resources/Training";
import ExerciseOptions from "../../components/geriactive/exercise/ExerciseOptions";
import Insights from "../../components/geriactive/insights/Insights";
import BibleStudyXframe from "../../components/geriactive/bibleStudy/BibleStudyXframe";

const geriactiveRoutes = [
  ...gameRoutes,
  <Route
    path="/presentation/morning-meeting"
    key="morning-meeting"
    title="Morning Meeting"
    element={<MeetingXframe />}
  />,
  <Route
    path="/presentation/afternoon-meeting"
    key="afternoon-meeting"
    element={<MeetingXframe />}
  />,
  <Route path="/exercise" key="exercise" element={<ExerciseOptions />} />,
  <Route
    path="/presentation/evening-meditation"
    key="evening-meditation"
    element={<MeditationXframe />}
  />,
  <Route
    path="/life-long-learning"
    key="life-long-learning-lesson"
    element={<LifeLongLearningXframe />}
  />,
  <Route
    path="/bible-study"
    key="bible-study"
    element={<BibleStudyXframe />}
  />,
  <Route path="/music" key="music" element={<Music />} />,
  <Route
    path="/music-selector"
    key="music-selector"
    element={<MusicSelector />}
  />,
  <Route path="/insights" key="insights" element={<Insights />} />,
  <Route path="/week-weather" key="week-weather" element={<WeatherWeek />} />,
  <Route path="/resource-selector" key="resource-selector"element={<ResourceSelector />} />,
  <Route path="/video-resources" key="video-resources" element={<VideoResources />} />,
  <Route path="/karaoke-resources" key="karaoke-resources" element={<KaraokeResources />} />,
  <Route path="/printable-activities" key="printable-activities" element={<PrintableActivities />} />,
  <Route path="/planning-tools" key="planning-tools" element={<PlanningTools />} />,
  <Route path="/training" key="training" element={<Training />} />,
  <Route path="/home" key="home" element={<HomePage />} />,
  <Route path="*" key="home-page" element={<HomePage />} />,
  <Route path="/" key="home-page-start" element={<HomePage />} />,
];

export default geriactiveRoutes;
